import {
    Paper,
    Stack,
    Typography,
    Box,
    TextField
} from "@mui/material";

export default function OTPMessageContentSection(
    {
        addSecurityRecommendation, setAddSecurityRecommendation,
        addExpirationTime, setAddExpirationTime,
        codeExpirationMinutes, setCodeExpirationMinutes
    }
) {
    return (
        <Paper variant="outlined" sx={{p: 2, borderRadius: 3}}>
            <Stack gap={1.5}>
                <Typography variant="h6">Message Content</Typography>
                <Typography variant="body2" color="text.secondary">
                    Content for authentication templates can’t be edited. You can add additional content from the
                    options below
                </Typography>

                {/* Security recommendation */}
                <Stack direction="row" alignItems="center" gap={1}>
                    <input
                        type="checkbox"
                        id="sec-reco"
                        checked={addSecurityRecommendation}
                        onChange={(e) => setAddSecurityRecommendation(e.target.checked)}
                        style={{width: 18, height: 18}}
                    />
                    <label htmlFor="sec-reco" style={{cursor: "pointer"}}>
                        Add Security recommendation
                    </label>
                </Stack>

                {/* Expiration time */}
                <Stack gap={0.5}>
                    <Stack direction="row" alignItems="center" gap={1}>
                        <input
                            type="checkbox"
                            id="exp-time"
                            checked={addExpirationTime}
                            onChange={(e) => setAddExpirationTime(e.target.checked)}
                            style={{width: 18, height: 18}}
                        />
                        <label htmlFor="exp-time" style={{cursor: "pointer"}}>
                            Add expiration time for code
                        </label>
                    </Stack>
                    <Typography variant="caption" color="text.secondary" sx={{ml: 3}}>
                        After the code expires, Autofill button will be disabled.
                    </Typography>

                    {addExpirationTime && (
                        <Box
                            sx={{
                                mt: 1,
                                borderRadius: 2,
                                border: (t) => `1px solid ${t.palette.primary.light}`,
                                bgcolor: (t) => (t.palette.mode === "light" ? "#f7f6ff" : "transparent"),
                                p: 2,
                                ml: {xs: 0, sm: 3}
                            }}
                        >
                            <Typography variant="caption" sx={{display: "block", mb: 0.5}}>
                                Minutes Value
                            </Typography>
                            <TextField
                                value={codeExpirationMinutes}
                                onChange={(e) => setCodeExpirationMinutes(e.target.value.replace(/\D/g, ""))}
                                placeholder="10"
                                inputProps={{inputMode: "numeric", pattern: "[0-9]*"}}
                                sx={{maxWidth: 220}}
                            />
                        </Box>
                    )}
                </Stack>
            </Stack>
        </Paper>
    );
}
